
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Web-Elements/Table.html",
      function () {
        return require("private-next-pages/Web-Elements/Table.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Web-Elements/Table.html"])
      });
    }
  